// extracted by mini-css-extract-plugin
module.exports = {"localHeroBadge":"LocalHeroBadge_localHeroBadge__vsGuX","localHeroIcon":"LocalHeroBadge_localHeroIcon___OzG8"};